// Template data configurations for preview functionality
export const templateData = {
  pizza: {
  "template":"Pizza",
  "theme": {
    "font": "poppins",
    "primarycolor": "#EF4444"
  },
  "widgets": [
    {
      "type": "BasicNav",
      "data": {
        "logoText": "Restaurant Name",
        "logoUrl": "",
        "contactInfo": "(555) 123-4567",
        "backgroundColor": "#1A1C1E",
        "textColor": "#FFFFFF",
        "fontFamily": "",
        "heroBarBackgroundColor": "#0f0f0f",
        "heroBarLabel": "",
        "heroBarTextColor": "#ffffff",
        "isTransparent": false,
        "showSearchIcon": true,
        "showSocialIcons": true,
        "showCartIcon": true,
        "showOrderButton": false,
        "orderButtonText": "Order Online",
        "orderButtonUrl": "",
        "showTakeout": true,
        "socialMedia": {
          "email": "",
          "facebook": "",
          "foursquare": "",
          "instagram": "",
          "tiktok": "",
          "tripadvisor": "",
          "yelp": ""
        },
        "takeoutText": "Takeout",
        "showDelivery": true,
        "showHeroBar": false,
        "showHeroBarLabel": false,
        "deliveryText": "Delivery",
        "deliveryUrl": "",
        "enableEmail": false,
        "enableFacebook": false,
        "enableFoursquare": false,
        "enableInstagram": false,
        "enableScrollTransparency": true,
        "enableTiktok": false,
        "enableTripadvisor": false,
        "enableYelp": false,
        "showCallToOrder": true,
        "callToOrderText": "Call to Order",
        "callToOrderNumber": "+1-555-123-4567",
        "showAnnouncementBar": false,
        "announcementContent": "🎉 Welcome! Check out our latest specials and offers!",
        "items": [
          {
            "dropdownLabel": "Menu",
            "hasSubMenu": false,
            "id": "menu",
            "label": "Menu",
            "url": "/menu",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Our Story",
            "hasSubMenu": false,
            "id": "story",
            "label": "Our Story",
            "url": "/our-story",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Blog",
            "hasSubMenu": false,
            "id": "blog",
            "label": "Blog",
            "url": "/blog",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Events",
            "hasSubMenu": false,
            "id": "events",
            "label": "Events",
            "url": "/events",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Gallery",
            "hasSubMenu": false,
            "id": "gallery",
            "label": "Gallery",
            "url": "/gallery",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Contact",
            "hasSubMenu": false,
            "id": "contact",
            "label": "Contact",
            "url": "/contact",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Table Reservations",
            "hasSubMenu": false,
            "id": "Table Reservations",
            "label": "Table Reservations",
            "url": "/Table-Reservations",
            "isEnabled": false,
            "subMenuItemIds": []
          }
        ]
      }
    },
    {
      "type": "BasicBanner",
      "data": {
       "slides": [
          {
            "id": "slide-1",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem Ipsum Dolor Sit Amet</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Consectetur Adipiscing Elit</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</span></p>",
            "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.5,
            "overlayColor": "rgba(0,0,0,0.5)",
            "ctaButtons": [
              {
                "id": "cta-1",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "",
                "variant": "primary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": true
              }
            ],
             "sectionBackgroundColor": "#100f0f"
          },
          {
            "id": "slide-2",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Dolor Sit Amet Consectetur</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Elit Sed Do Eiusmod</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</span></p>",
            "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.4,
            "overlayColor": "rgba(0,0,0,0.4)",
            "ctaButtons": [
              {
                "id": "cta-2",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "/sample-two",
                "variant": "secondary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": false
              }
            ],
            "sectionBackgroundColor": "#100f0f"
          }
        ]
      }
    },
    {
      "type": "BasicPopularItems",
      "data": {
        "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
        "backgroundColor": "#ffffff",
        "selectedItemIds": [],
        "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
        "showRating": true,
        "menuData": []
      }
    },
    {
      "type": "BasicMenu",
      "data": {}
    },
    {
      "type": "BasicExperienceCard",
      "data": {
        "headerContent": "<h2><br></h2><h2>Our Culinary Experience</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p><br></p>",
        "cards": [
          {
            "id": "1",
            "title": "<h3 class='text-xl font-semibold mb-2'>Fresh Ingredients</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.</p>",
            "image": "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&h=400&fit=crop",
            "icon": "🥗"
          },
          {
            "id": "2",
            "title": "<h3 class='text-xl font-semibold mb-2'>Expert Chefs</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.</p>",
            "image": "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=600&h=400&fit=crop",
            "icon": "👨‍🍳"
          },
          {
            "id": "3",
            "title": "<h3 class='text-xl font-semibold mb-2'>Warm Ambiance</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nec tellus sed augue semper porta. Mauris massa.</p>",
            "image": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=400&fit=crop",
            "icon": "🏠"
          },
          {
            "id": "4",
            "title": "<h3 class='text-xl font-semibold mb-2'>Customer Satisfaction</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>",
            "image": "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&h=400&fit=crop",
            "icon": "🌟"
          }
        ],
        "backgroundColor": "#fff7f3"
      }
    },
    {
      "type": "BasicFooter",
      "data": {
        "address": "123 Main Street, Lorem City, Ipsum State 12345",
        "backgroundColor": "#000000",
        "borderColor": "#334155",
        "copyrightText": "<p>© 2025 <strong>Your Restaurant</strong>. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
        "description": "<p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>. Vivamus ut nulla nec justo pretium porta. Integer euismod, magna ac <em>volutpat facilisis</em>, velit purus tempus metus, at <strong>faucibus mauris</strong> sem vel nisi.</p>",
        "email": "info@yourrestaurant.com",
        "hours": "Mon–Thu: 11am–10pm | Fri–Sat: 11am–11pm | Sun: 12pm–9pm",
        "legalLinks": [
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt, nibh vel laoreet pulvinar, neque massa accumsan turpis, sed porta risus mi non purus.</p>",
            "id": "1",
            "label": "Privacy Policy",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ultricies, orci vel interdum tempor, lorem arcu tempor nisi, vel egestas libero magna nec risus.</p>",
            "id": "2",
            "label": "Terms of Service",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut dignissim diam vel nisl vestibulum, nec vestibulum felis euismod.</p>",
            "id": "3",
            "label": "Cookie Policy",
            "url": ""
          }
        ],
        "linkColor": "#f59e0b",
        "phone": "(555) 123-4567",
        "restaurantName": "SnapFeast",
        "socialLinks": [
          {
            "enabled": false,
            "id": "1",
            "platform": "facebook",
            "url": ""
          },
          {
            "enabled": false,
            "id": "2",
            "platform": "instagram",
            "url": ""
          },
          {
            "enabled": false,
            "id": "3",
            "platform": "twitter",
            "url": ""
          },
          {
            "enabled": false,
            "id": "4",
            "platform": "linkedin",
            "url": ""
          },
          {
            "enabled": false,
            "id": "5",
            "platform": "email",
            "url": ""
          },
          {
            "enabled": false,
            "id": "6",
            "platform": "tiktok",
            "url": ""
          },
          {
            "enabled": false,
            "id": "7",
            "platform": "yelp",
            "url": ""
          },
          {
            "enabled": false,
            "id": "8",
            "platform": "tripadvisor",
            "url": ""
          },
          {
            "enabled": false,
            "id": "9",
            "platform": "foursquare",
            "url": ""
          }
        ],
        "textColor": "#f1f5f9"
      }
    }
  ],
  "pages": {
    "our-story": {
      "widgets": [
        {
          "type": "BasicStory",
          "data": {
            "hero": {
              "image": "https://www.leedsindiefood.com/wp-content/uploads/2022/04/LIF19-140519-Web-Ben_Bentley-2520-Web-2000x1335.jpeg",
              "title": "<h2>Lorem Ipsum Our Story</h2>"
            },
            "title": "<h3>The Story of Our Lorem Ipsum Restaurant</h3>",
            "storyContent": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. This is sample content for demonstration purposes and can be replaced later.</p>"
          }
        }
      ],
      "title": "our-story"
    },
    "blog": {
      "widgets": [
        {
          "type": "BasicBlog",
          "data": {
            "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Lorem Ipsum Blog Posts</h2>",
            "subtitle": "<p class='text-gray-600 text-lg'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Discover our latest stories and insights.</p>",
            "posts": [
              {
                "id": "1",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post One</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text.</p>",
                "image": "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/8103728/106960_386746.png",
                "date": "2024-01-01T00:00:00.000Z",
                "readTime": "5 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              },
              {
                "id": "2",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post Two</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text for the second blog post.</p>",
                "image": "https://www.thatgoangirl.com/wp-content/uploads/2020/05/anonymous-crop-person-taking-photo-of-food-on-smartphone-at-3850226-1-1440x960.jpg",
                "date": "2024-01-02T00:00:00.000Z",
                "readTime": "3 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              }
            ],
            "postsPerPage": 6,
            "showCategory": true,
            "showReadTime": true,
            "showAuthor": false,
            "backgroundColor": "#ffffff",
            "textColor": "#1f2937",
            "cardBackgroundColor": "#ffffff",
            "primaryColor": "#EF4444"
          }
        }
      ],
      "title": "blog"
    },
    "events": {
      "widgets": [
        {
          "type": "BasicEvents",
          "data": {
            "isEnabled": true,
            "section": {
              "title": "<h2>Upcoming Events</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stay tuned for our latest events!</p>",
              "primaryColor": "#EF4444",
              "secondaryColor": "#DC2626",
              "accentColor": "#B91C1C",
              "textColor": "#374151"
            },
            "items": [
              {
                "id": "event-1",
                "title": "<h3>Lorem Ipsum Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum. Event details will be updated soon.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-01-01",
                "time": "18:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              },
              {
                "id": "event-2",
                "title": "<h3>Dolor Sit Amet Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-02-15",
                "time": "20:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              }
            ]
          }
        }
      ],
      "title": "events"
    },
    "gallery": {
      "widgets": [
        {
          "type": "BasicGallery",
          "data": {
            "section": {
              "title": "<h2>Lorem Ipsum Culinary Artistry</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. A visual celebration of our gastronomic creations.</p>",
              "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony.</p>"
            },
            "images": [
              {
                "id": "1",
                "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Elegant Presentation</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Where artistry meets gastronomy.</p>",
                "isVisible": true
              },
              {
                "id": "2",
                "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Chef's Precision</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Meticulous attention to every detail.</p>",
                "isVisible": true
              },
              {
                "id": "3",
                "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Premium Ingredients</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Only the finest seasonal selections.</p>",
                "isVisible": true
              },
              {
                "id": "4",
                "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Sophisticated Ambiance</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. An atmosphere of refined elegance.</p>",
                "isVisible": true
              }
            ],
            "cta": {
              "text": "<span>Lorem Ipsum Follow @CulinaryJourney</span>",
              "link": "https://instagram.com/culinaryjourney"
            }
          }
        }
      ],
      "title": "gallery"
    },
    "contact": {
      "widgets": [
        {
          "type": "BasicContactForm",
          "data": {
            "title": "Contact Us",
            "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
            "primaryColor": "#E7000B",
            "textColor": "#1F2937",
            "backgroundColor": "#FFFFFF",
            "formBackgroundColor": "#F9FAFB",
            "cardBackgroundColor": "#FFFFFF",
            "submitButtonText": "SUBMIT",
            "successMessage": "Thank you for reaching out! This is a sample success message.",
            "errorMessage": "Oops! Something went wrong. Please try again later.",
            "contactInfo": {
              "email": {
                "title": "Email Us",
                "description": "Send us an email",
                "address": "info@sample.com"
              },
              "phone": {
                "title": "Call Us",
                "description": "Call us directly",
                "number": "(000) 000-0000"
              },
              "address": {
                "title": "Visit Us",
                "description": "Visit our office",
                "full": "123 Sample Street, Sample City, Country"
              }
            },
            "formFields": {
              "name": {
                "enabled": true,
                "required": true,
                "label": "Name",
                "placeholder": "Your Name"
              },
              "email": {
                "enabled": true,
                "required": true,
                "label": "Email",
                "placeholder": "Your Email"
              },
              "phone": {
                "enabled": true,
                "required": false,
                "label": "Phone",
                "placeholder": "Your Phone"
              },
              "message": {
                "enabled": true,
                "required": true,
                "label": "Message",
                "placeholder": "Your Message"
              }
            }
          }
        }
      ],
      "title": "contact"
    }
  }
},

  culinary_journey: {
  "template":"CulinaryJourney",
  "theme": {
    "font": "poppins",
    "primarycolor": "#5A3068"
  },
  "widgets": [
    {
      "type": "ClassicNav",
      "data": {
        "logoText": "Restaurant Name",
        "logoUrl": "",
        "contactInfo": "(555) 123-4567",
        "backgroundColor": "#1A1C1E",
        "textColor": "#FFFFFF",
        "fontFamily": "",
        "heroBarBackgroundColor": "#0f0f0f",
        "heroBarLabel": "",
        "heroBarTextColor": "#ffffff",
        "isTransparent": false,
        "showSearchIcon": true,
        "showSocialIcons": true,
        "showCartIcon": true,
        "showOrderButton": false,
        "orderButtonText": "Order Online",
        "orderButtonUrl": "",
        "showTakeout": true,
        "socialMedia": {
          "email": "",
          "facebook": "",
          "foursquare": "",
          "instagram": "",
          "tiktok": "",
          "tripadvisor": "",
          "yelp": ""
        },
        "takeoutText": "Takeout",
        "showDelivery": true,
        "showHeroBar": false,
        "showHeroBarLabel": false,
        "deliveryText": "Delivery",
        "deliveryUrl": "",
        "enableEmail": false,
        "enableFacebook": false,
        "enableFoursquare": false,
        "enableInstagram": false,
        "enableScrollTransparency": true,
        "enableTiktok": false,
        "enableTripadvisor": false,
        "enableYelp": false,
        "showCallToOrder": true,
        "callToOrderText": "Call to Order",
        "callToOrderNumber": "+1-555-123-4567",
        "showAnnouncementBar": false,
        "announcementContent": "🎉 Welcome! Check out our latest specials and offers!",
        "items": [
          {
            "dropdownLabel": "Menu",
            "hasSubMenu": false,
            "id": "menu",
            "label": "Menu",
            "url": "/menu",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Our Story",
            "hasSubMenu": false,
            "id": "story",
            "label": "Our Story",
            "url": "/our-story",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Blog",
            "hasSubMenu": false,
            "id": "blog",
            "label": "Blog",
            "url": "/blog",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Events",
            "hasSubMenu": false,
            "id": "events",
            "label": "Events",
            "url": "/events",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Gallery",
            "hasSubMenu": false,
            "id": "gallery",
            "label": "Gallery",
            "url": "/gallery",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Contact",
            "hasSubMenu": false,
            "id": "contact",
            "label": "Contact",
            "url": "/contact",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Table Reservations",
            "hasSubMenu": false,
            "id": "Table Reservations",
            "label": "Table Reservations",
            "url": "/Table-Reservations",
            "isEnabled": false,
            "subMenuItemIds": []
          }
        ]
      }
    },
    {
      "type": "ClassicBanner",
      "data": {
      "slides": [
          {
            "id": "slide-1",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem Ipsum Dolor Sit Amet</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Consectetur Adipiscing Elit</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</span></p>",
            "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.5,
            "overlayColor": "rgba(0,0,0,0.5)",
            "ctaButtons": [
              {
                "id": "cta-1",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "",
                "variant": "primary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": true
              }
            ],
             "sectionBackgroundColor": "#100f0f"
          },
          {
            "id": "slide-2",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Dolor Sit Amet Consectetur</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Elit Sed Do Eiusmod</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</span></p>",
            "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.4,
            "overlayColor": "rgba(0,0,0,0.4)",
            "ctaButtons": [
              {
                "id": "cta-2",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "/sample-two",
                "variant": "secondary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": false
              }
            ],
            "sectionBackgroundColor": "#100f0f"
          }
        ]
      }
    },
    {
      "type": "ClassicPopularItems",
      "data": {
        "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
        "backgroundColor": "#ffffff",
        "selectedItemIds": [],
        "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
        "showRating": true,
        "menuData": []
      }
    },
    {
      "type": "ClassicMenu",
      "data": {}
    },
    {
      "type": "ClassicExperienceCard",
      "data": {
        "headerContent": "<h2><br></h2><h2>Our Culinary Experience</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p><br></p>",
        "cards": [
          {
            "id": "1",
            "title": "<h3 class='text-xl font-semibold mb-2'>Fresh Ingredients</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.</p>",
            "image": "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&h=400&fit=crop",
            "icon": "🥗"
          },
          {
            "id": "2",
            "title": "<h3 class='text-xl font-semibold mb-2'>Expert Chefs</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.</p>",
            "image": "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=600&h=400&fit=crop",
            "icon": "👨‍🍳"
          },
          {
            "id": "3",
            "title": "<h3 class='text-xl font-semibold mb-2'>Warm Ambiance</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nec tellus sed augue semper porta. Mauris massa.</p>",
            "image": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=400&fit=crop",
            "icon": "🏠"
          },
          {
            "id": "4",
            "title": "<h3 class='text-xl font-semibold mb-2'>Customer Satisfaction</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>",
            "image": "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&h=400&fit=crop",
            "icon": "🌟"
          }
        ],
        "backgroundColor": "#fff7f3"
      }
    },
    {
      "type": "ClassicFooter",
      "data": {
        "address": "123 Main Street, Lorem City, Ipsum State 12345",
        "backgroundColor": "#000000",
        "borderColor": "#334155",
        "copyrightText": "<p>© 2025 <strong>Your Restaurant</strong>. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
        "description": "<p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>. Vivamus ut nulla nec justo pretium porta. Integer euismod, magna ac <em>volutpat facilisis</em>, velit purus tempus metus, at <strong>faucibus mauris</strong> sem vel nisi.</p>",
        "email": "info@yourrestaurant.com",
        "hours": "Mon–Thu: 11am–10pm | Fri–Sat: 11am–11pm | Sun: 12pm–9pm",
        "legalLinks": [
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt, nibh vel laoreet pulvinar, neque massa accumsan turpis, sed porta risus mi non purus.</p>",
            "id": "1",
            "label": "Privacy Policy",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ultricies, orci vel interdum tempor, lorem arcu tempor nisi, vel egestas libero magna nec risus.</p>",
            "id": "2",
            "label": "Terms of Service",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut dignissim diam vel nisl vestibulum, nec vestibulum felis euismod.</p>",
            "id": "3",
            "label": "Cookie Policy",
            "url": ""
          }
        ],
        "linkColor": "#f59e0b",
        "phone": "(555) 123-4567",
        "restaurantName": "SnapFeast",
        "socialLinks": [
          {
            "enabled": false,
            "id": "1",
            "platform": "facebook",
            "url": ""
          },
          {
            "enabled": false,
            "id": "2",
            "platform": "instagram",
            "url": ""
          },
          {
            "enabled": false,
            "id": "3",
            "platform": "twitter",
            "url": ""
          },
          {
            "enabled": false,
            "id": "4",
            "platform": "linkedin",
            "url": ""
          },
          {
            "enabled": false,
            "id": "5",
            "platform": "email",
            "url": ""
          },
          {
            "enabled": false,
            "id": "6",
            "platform": "tiktok",
            "url": ""
          },
          {
            "enabled": false,
            "id": "7",
            "platform": "yelp",
            "url": ""
          },
          {
            "enabled": false,
            "id": "8",
            "platform": "tripadvisor",
            "url": ""
          },
          {
            "enabled": false,
            "id": "9",
            "platform": "foursquare",
            "url": ""
          }
        ],
        "textColor": "#f1f5f9"
      }
    }
  ],
  "pages": {
    "our-story": {
      "widgets": [
        {
          "type": "ClassicStory",
          "data": {
            "hero": {
              "image": "https://www.leedsindiefood.com/wp-content/uploads/2022/04/LIF19-140519-Web-Ben_Bentley-2520-Web-2000x1335.jpeg",
              "title": "<h2>Lorem Ipsum Our Story</h2>"
            },
            "title": "<h3>The Story of Our Lorem Ipsum Restaurant</h3>",
            "storyContent": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. This is sample content for demonstration purposes and can be replaced later.</p>"
          }
        }
      ],
      "title": "our-story"
    },
    "blog": {
      "widgets": [
        {
          "type": "ClassicBlog",
          "data": {
            "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Lorem Ipsum Blog Posts</h2>",
            "subtitle": "<p class='text-gray-600 text-lg'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Discover our latest stories and insights.</p>",
            "posts": [
              {
                "id": "1",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post One</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text.</p>",
                "image": "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/8103728/106960_386746.png",
                "date": "2024-01-01T00:00:00.000Z",
                "readTime": "5 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              },
              {
                "id": "2",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post Two</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text for the second blog post.</p>",
                "image": "https://www.thatgoangirl.com/wp-content/uploads/2020/05/anonymous-crop-person-taking-photo-of-food-on-smartphone-at-3850226-1-1440x960.jpg",
                "date": "2024-01-02T00:00:00.000Z",
                "readTime": "3 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              }
            ],
            "postsPerPage": 6,
            "showCategory": true,
            "showReadTime": true,
            "showAuthor": false,
            "backgroundColor": "#ffffff",
            "textColor": "#1f2937",
            "cardBackgroundColor": "#ffffff",
            "primaryColor": "#EF4444"
          }
        }
      ],
      "title": "blog"
    },
    "events": {
      "widgets": [
        {
          "type": "ClassicEvents",
          "data": {
            "isEnabled": true,
            "section": {
              "title": "<h2>Upcoming Events</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stay tuned for our latest events!</p>",
              "primaryColor": "#EF4444",
              "secondaryColor": "#DC2626",
              "accentColor": "#B91C1C",
              "textColor": "#374151"
            },
            "items": [
              {
                "id": "event-1",
                "title": "<h3>Lorem Ipsum Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum. Event details will be updated soon.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-01-01",
                "time": "18:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              },
              {
                "id": "event-2",
                "title": "<h3>Dolor Sit Amet Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-02-15",
                "time": "20:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              }
            ]
          }
        }
      ],
      "title": "events"
    },
    "gallery": {
      "widgets": [
        {
          "type": "ClassicGallery",
          "data": {
            "section": {
              "title": "<h2>Lorem Ipsum Culinary Artistry</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. A visual celebration of our gastronomic creations.</p>",
              "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony.</p>"
            },
            "images": [
              {
                "id": "1",
                "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Elegant Presentation</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Where artistry meets gastronomy.</p>",
                "isVisible": true
              },
              {
                "id": "2",
                "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Chef's Precision</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Meticulous attention to every detail.</p>",
                "isVisible": true
              },
              {
                "id": "3",
                "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Premium Ingredients</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Only the finest seasonal selections.</p>",
                "isVisible": true
              },
              {
                "id": "4",
                "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Sophisticated Ambiance</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. An atmosphere of refined elegance.</p>",
                "isVisible": true
              }
            ],
            "cta": {
              "text": "<span>Lorem Ipsum Follow @CulinaryJourney</span>",
              "link": "https://instagram.com/culinaryjourney"
            }
          }
        }
      ],
      "title": "gallery"
    },
    "contact": {
      "widgets": [
        {
          "type": "ClassicContactForm",
          "data": {
            "title": "Contact Us",
            "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
            "primaryColor": "#E7000B",
            "textColor": "#1F2937",
            "backgroundColor": "#FFFFFF",
            "formBackgroundColor": "#F9FAFB",
            "cardBackgroundColor": "#FFFFFF",
            "submitButtonText": "SUBMIT",
            "successMessage": "Thank you for reaching out! This is a sample success message.",
            "errorMessage": "Oops! Something went wrong. Please try again later.",
            "contactInfo": {
              "email": {
                "title": "Email Us",
                "description": "Send us an email",
                "address": "info@sample.com"
              },
              "phone": {
                "title": "Call Us",
                "description": "Call us directly",
                "number": "(000) 000-0000"
              },
              "address": {
                "title": "Visit Us",
                "description": "Visit our office",
                "full": "123 Sample Street, Sample City, Country"
              }
            },
            "formFields": {
              "name": {
                "enabled": true,
                "required": true,
                "label": "Name",
                "placeholder": "Your Name"
              },
              "email": {
                "enabled": true,
                "required": true,
                "label": "Email",
                "placeholder": "Your Email"
              },
              "phone": {
                "enabled": true,
                "required": false,
                "label": "Phone",
                "placeholder": "Your Phone"
              },
              "message": {
                "enabled": true,
                "required": true,
                "label": "Message",
                "placeholder": "Your Message"
              }
            }
          }
        }
      ],
      "title": "contact"
    }
  }
},

  eatflow: {
  "template":"EatFlow",
  "theme": {
    "font": "poppins",
    "primarycolor": "#FFA700"
  },
  "widgets": [
    {
      "type": "EssentialNav",
      "data": {
        "logoText": "Restaurant Name",
        "logoUrl": "",
        "contactInfo": "(555) 123-4567",
        "backgroundColor": "#1A1C1E",
        "textColor": "#FFFFFF",
        "fontFamily": "",
        "heroBarBackgroundColor": "#0f0f0f",
        "heroBarLabel": "",
        "heroBarTextColor": "#ffffff",
        "isTransparent": false,
        "showSearchIcon": true,
        "showSocialIcons": true,
        "showCartIcon": true,
        "showOrderButton": false,
        "orderButtonText": "Order Online",
        "orderButtonUrl": "",
        "showTakeout": true,
        "socialMedia": {
          "email": "",
          "facebook": "",
          "foursquare": "",
          "instagram": "",
          "tiktok": "",
          "tripadvisor": "",
          "yelp": ""
        },
        "takeoutText": "Takeout",
        "showDelivery": true,
        "showHeroBar": false,
        "showHeroBarLabel": false,
        "deliveryText": "Delivery",
        "deliveryUrl": "",
        "enableEmail": false,
        "enableFacebook": false,
        "enableFoursquare": false,
        "enableInstagram": false,
        "enableScrollTransparency": true,
        "enableTiktok": false,
        "enableTripadvisor": false,
        "enableYelp": false,
        "showCallToOrder": true,
        "callToOrderText": "Call to Order",
        "callToOrderNumber": "+1-555-123-4567",
        "showAnnouncementBar": false,
        "announcementContent": "🎉 Welcome! Check out our latest specials and offers!",
        "items": [
          {
            "dropdownLabel": "Menu",
            "hasSubMenu": false,
            "id": "menu",
            "label": "Menu",
            "url": "/menu",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Our Story",
            "hasSubMenu": false,
            "id": "story",
            "label": "Our Story",
            "url": "/our-story",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Blog",
            "hasSubMenu": false,
            "id": "blog",
            "label": "Blog",
            "url": "/blog",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Events",
            "hasSubMenu": false,
            "id": "events",
            "label": "Events",
            "url": "/events",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Gallery",
            "hasSubMenu": false,
            "id": "gallery",
            "label": "Gallery",
            "url": "/gallery",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Contact",
            "hasSubMenu": false,
            "id": "contact",
            "label": "Contact",
            "url": "/contact",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Table Reservations",
            "hasSubMenu": false,
            "id": "Table Reservations",
            "label": "Table Reservations",
            "url": "/Table-Reservations",
            "isEnabled": false,
            "subMenuItemIds": []
          }
        ]
      }
    },
    {
      "type": "EssentialBanner",
      "data": {
       "slides": [
          {
            "id": "slide-1",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem Ipsum Dolor Sit Amet</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Consectetur Adipiscing Elit</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</span></p>",
            "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.5,
            "overlayColor": "rgba(0,0,0,0.5)",
            "ctaButtons": [
              {
                "id": "cta-1",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "",
                "variant": "primary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": true
              }
            ],
             "sectionBackgroundColor": "#100f0f"
          },
          {
            "id": "slide-2",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Dolor Sit Amet Consectetur</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Elit Sed Do Eiusmod</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</span></p>",
            "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.4,
            "overlayColor": "rgba(0,0,0,0.4)",
            "ctaButtons": [
              {
                "id": "cta-2",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "/sample-two",
                "variant": "secondary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": false
              }
            ],
            "sectionBackgroundColor": "#100f0f"
          }
        ]
      }
    },
    {
      "type": "EssentialPopularItems",
      "data": {
        "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
        "backgroundColor": "#ffffff",
        "selectedItemIds": [],
        "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
        "showRating": true,
        "menuData": []
      }
    },
    {
      "type": "PrimeMenu",
      "data": {}
    },
    {
      "type": "EssentialExperience",
      "data": {
        "headerContent": "<h2><br></h2><h2>Our Culinary Experience</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p><br></p>",
        "cards": [
          {
            "id": "1",
            "title": "<h3 class='text-xl font-semibold mb-2'>Fresh Ingredients</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.</p>",
            "image": "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&h=400&fit=crop",
            "icon": "🥗"
          },
          {
            "id": "2",
            "title": "<h3 class='text-xl font-semibold mb-2'>Expert Chefs</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.</p>",
            "image": "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=600&h=400&fit=crop",
            "icon": "👨‍🍳"
          },
          {
            "id": "3",
            "title": "<h3 class='text-xl font-semibold mb-2'>Warm Ambiance</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nec tellus sed augue semper porta. Mauris massa.</p>",
            "image": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=400&fit=crop",
            "icon": "🏠"
          },
          {
            "id": "4",
            "title": "<h3 class='text-xl font-semibold mb-2'>Customer Satisfaction</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>",
            "image": "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&h=400&fit=crop",
            "icon": "🌟"
          }
        ],
        "backgroundColor": "#fff7f3"
      }
    },
    {
      "type": "EssentialFooter",
      "data": {
        "address": "123 Main Street, Lorem City, Ipsum State 12345",
        "backgroundColor": "#000000",
        "borderColor": "#334155",
        "copyrightText": "<p>© 2025 <strong>Your Restaurant</strong>. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
        "description": "<p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>. Vivamus ut nulla nec justo pretium porta. Integer euismod, magna ac <em>volutpat facilisis</em>, velit purus tempus metus, at <strong>faucibus mauris</strong> sem vel nisi.</p>",
        "email": "info@yourrestaurant.com",
        "hours": "Mon–Thu: 11am–10pm | Fri–Sat: 11am–11pm | Sun: 12pm–9pm",
        "legalLinks": [
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt, nibh vel laoreet pulvinar, neque massa accumsan turpis, sed porta risus mi non purus.</p>",
            "id": "1",
            "label": "Privacy Policy",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ultricies, orci vel interdum tempor, lorem arcu tempor nisi, vel egestas libero magna nec risus.</p>",
            "id": "2",
            "label": "Terms of Service",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut dignissim diam vel nisl vestibulum, nec vestibulum felis euismod.</p>",
            "id": "3",
            "label": "Cookie Policy",
            "url": ""
          }
        ],
        "linkColor": "#f59e0b",
        "phone": "(555) 123-4567",
        "restaurantName": "SnapFeast",
        "socialLinks": [
          {
            "enabled": false,
            "id": "1",
            "platform": "facebook",
            "url": ""
          },
          {
            "enabled": false,
            "id": "2",
            "platform": "instagram",
            "url": ""
          },
          {
            "enabled": false,
            "id": "3",
            "platform": "twitter",
            "url": ""
          },
          {
            "enabled": false,
            "id": "4",
            "platform": "linkedin",
            "url": ""
          },
          {
            "enabled": false,
            "id": "5",
            "platform": "email",
            "url": ""
          },
          {
            "enabled": false,
            "id": "6",
            "platform": "tiktok",
            "url": ""
          },
          {
            "enabled": false,
            "id": "7",
            "platform": "yelp",
            "url": ""
          },
          {
            "enabled": false,
            "id": "8",
            "platform": "tripadvisor",
            "url": ""
          },
          {
            "enabled": false,
            "id": "9",
            "platform": "foursquare",
            "url": ""
          }
        ],
        "textColor": "#f1f5f9"
      }
    }
  ],
  "pages": {
    "our-story": {
      "widgets": [
        {
          "type": "PrimeStory",
          "data": {
            "hero": {
              "image": "https://www.leedsindiefood.com/wp-content/uploads/2022/04/LIF19-140519-Web-Ben_Bentley-2520-Web-2000x1335.jpeg",
              "title": "<h2>Lorem Ipsum Our Story</h2>"
            },
            "title": "<h3>The Story of Our Lorem Ipsum Restaurant</h3>",
            "storyContent": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. This is sample content for demonstration purposes and can be replaced later.</p>"
          }
        }
      ],
      "title": "our-story"
    },
    "blog": {
      "widgets": [
        {
          "type": "PrimeBlog",
          "data": {
            "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Lorem Ipsum Blog Posts</h2>",
            "subtitle": "<p class='text-gray-600 text-lg'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Discover our latest stories and insights.</p>",
            "posts": [
              {
                "id": "1",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post One</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text.</p>",
                "image": "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/8103728/106960_386746.png",
                "date": "2024-01-01T00:00:00.000Z",
                "readTime": "5 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              },
              {
                "id": "2",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post Two</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text for the second blog post.</p>",
                "image": "https://www.thatgoangirl.com/wp-content/uploads/2020/05/anonymous-crop-person-taking-photo-of-food-on-smartphone-at-3850226-1-1440x960.jpg",
                "date": "2024-01-02T00:00:00.000Z",
                "readTime": "3 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              }
            ],
            "postsPerPage": 6,
            "showCategory": true,
            "showReadTime": true,
            "showAuthor": false,
            "backgroundColor": "#ffffff",
            "textColor": "#1f2937",
            "cardBackgroundColor": "#ffffff",
            "primaryColor": "#EF4444"
          }
        }
      ],
      "title": "blog"
    },
    "events": {
      "widgets": [
        {
          "type": "PrimeEvents",
          "data": {
            "isEnabled": true,
            "section": {
              "title": "<h2>Upcoming Events</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stay tuned for our latest events!</p>",
              "primaryColor": "#EF4444",
              "secondaryColor": "#DC2626",
              "accentColor": "#B91C1C",
              "textColor": "#374151"
            },
            "items": [
              {
                "id": "event-1",
                "title": "<h3>Lorem Ipsum Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum. Event details will be updated soon.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-01-01",
                "time": "18:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              },
              {
                "id": "event-2",
                "title": "<h3>Dolor Sit Amet Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-02-15",
                "time": "20:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              }
            ]
          }
        }
      ],
      "title": "events"
    },
    "gallery": {
      "widgets": [
        {
          "type": "PrimeGallery",
          "data": {
            "section": {
              "title": "<h2>Lorem Ipsum Culinary Artistry</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. A visual celebration of our gastronomic creations.</p>",
              "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony.</p>"
            },
            "images": [
              {
                "id": "1",
                "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Elegant Presentation</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Where artistry meets gastronomy.</p>",
                "isVisible": true
              },
              {
                "id": "2",
                "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Chef's Precision</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Meticulous attention to every detail.</p>",
                "isVisible": true
              },
              {
                "id": "3",
                "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Premium Ingredients</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Only the finest seasonal selections.</p>",
                "isVisible": true
              },
              {
                "id": "4",
                "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Sophisticated Ambiance</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. An atmosphere of refined elegance.</p>",
                "isVisible": true
              }
            ],
            "cta": {
              "text": "<span>Lorem Ipsum Follow @CulinaryJourney</span>",
              "link": "https://instagram.com/culinaryjourney"
            }
          }
        }
      ],
      "title": "gallery"
    },
    "contact": {
      "widgets": [
        {
          "type": "PrimeContactForm",
          "data": {
            "title": "Contact Us",
            "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
            "primaryColor": "#E7000B",
            "textColor": "#1F2937",
            "backgroundColor": "#FFFFFF",
            "formBackgroundColor": "#F9FAFB",
            "cardBackgroundColor": "#FFFFFF",
            "submitButtonText": "SUBMIT",
            "successMessage": "Thank you for reaching out! This is a sample success message.",
            "errorMessage": "Oops! Something went wrong. Please try again later.",
            "contactInfo": {
              "email": {
                "title": "Email Us",
                "description": "Send us an email",
                "address": "info@sample.com"
              },
              "phone": {
                "title": "Call Us",
                "description": "Call us directly",
                "number": "(000) 000-0000"
              },
              "address": {
                "title": "Visit Us",
                "description": "Visit our office",
                "full": "123 Sample Street, Sample City, Country"
              }
            },
            "formFields": {
              "name": {
                "enabled": true,
                "required": true,
                "label": "Name",
                "placeholder": "Your Name"
              },
              "email": {
                "enabled": true,
                "required": true,
                "label": "Email",
                "placeholder": "Your Email"
              },
              "phone": {
                "enabled": true,
                "required": false,
                "label": "Phone",
                "placeholder": "Your Phone"
              },
              "message": {
                "enabled": true,
                "required": true,
                "label": "Message",
                "placeholder": "Your Message"
              }
            }
          }
        }
      ],
      "title": "contact"
    }
  }
},

  casual_dining: {
  "template":"CasualDining",
  "theme": {
    "font": "poppins",
    "primarycolor": "#FD49E5"
  },
  "widgets": [
    {
      "type": "PrimeNav",
      "data": {
        "logoText": "Restaurant Name",
        "logoUrl": "",
        "contactInfo": "(555) 123-4567",
        "backgroundColor": "#1A1C1E",
        "textColor": "#FFFFFF",
        "fontFamily": "",
        "heroBarBackgroundColor": "#0f0f0f",
        "heroBarLabel": "",
        "heroBarTextColor": "#ffffff",
        "isTransparent": false,
        "showSearchIcon": true,
        "showSocialIcons": true,
        "showCartIcon": true,
        "showOrderButton": false,
        "orderButtonText": "Order Online",
        "orderButtonUrl": "",
        "showTakeout": true,
        "socialMedia": {
          "email": "",
          "facebook": "",
          "foursquare": "",
          "instagram": "",
          "tiktok": "",
          "tripadvisor": "",
          "yelp": ""
        },
        "takeoutText": "Takeout",
        "showDelivery": true,
        "showHeroBar": false,
        "showHeroBarLabel": false,
        "deliveryText": "Delivery",
        "deliveryUrl": "",
        "enableEmail": false,
        "enableFacebook": false,
        "enableFoursquare": false,
        "enableInstagram": false,
        "enableScrollTransparency": true,
        "enableTiktok": false,
        "enableTripadvisor": false,
        "enableYelp": false,
        "showCallToOrder": true,
        "callToOrderText": "Call to Order",
        "callToOrderNumber": "+1-555-123-4567",
        "showAnnouncementBar": false,
        "announcementContent": "🎉 Welcome! Check out our latest specials and offers!",
        "items": [
          {
            "dropdownLabel": "Menu",
            "hasSubMenu": false,
            "id": "menu",
            "label": "Menu",
            "url": "/menu",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Our Story",
            "hasSubMenu": false,
            "id": "story",
            "label": "Our Story",
            "url": "/our-story",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Blog",
            "hasSubMenu": false,
            "id": "blog",
            "label": "Blog",
            "url": "/blog",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Events",
            "hasSubMenu": false,
            "id": "events",
            "label": "Events",
            "url": "/events",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Gallery",
            "hasSubMenu": false,
            "id": "gallery",
            "label": "Gallery",
            "url": "/gallery",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Contact",
            "hasSubMenu": false,
            "id": "contact",
            "label": "Contact",
            "url": "/contact",
            "isEnabled": true,
            "subMenuItemIds": []
          },
          {
            "dropdownLabel": "Table Reservations",
            "hasSubMenu": false,
            "id": "Table Reservations",
            "label": "Table Reservations",
            "url": "/Table-Reservations",
            "isEnabled": false,
            "subMenuItemIds": []
          }
        ]
      }
    },
    {
      "type": "PrimeBanner",
      "data": {
        "slides": [
          {
            "id": "slide-1",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem Ipsum Dolor Sit Amet</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Consectetur Adipiscing Elit</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</span></p>",
            "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.5,
            "overlayColor": "rgba(0,0,0,0.5)",
            "ctaButtons": [
              {
                "id": "cta-1",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "",
                "variant": "primary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": true
              }
            ],
             "sectionBackgroundColor": "#100f0f"
          },
          {
            "id": "slide-2",
            "title": "<h2><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Dolor Sit Amet Consectetur</span></h2>",
            "subtitle": "<h4><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Elit Sed Do Eiusmod</span></h4>",
            "description": "<p><span style=\"color: rgb(255, 255, 255);\" class=\"force-visible-white-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</span></p>",
            "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
            "backgroundVideo": "",
            "backgroundColor": "#FFFFFF",
            "textAlignment": "center",
            "textColor": "#ffffff",
            "overlayOpacity": 0.4,
            "overlayColor": "rgba(0,0,0,0.4)",
            "ctaButtons": [
              {
                "id": "cta-2",
                "linkType": "nav-item",
                "navItemUrl": "/menu",
                "outlineColor": "#ffffff",
                "text": "<span>Lorem Ipsum</span>",
                "url": "/sample-two",
                "variant": "secondary",
                "backgroundColor": "#EF4444",
                "color": "#ffffff",
                "visible": false
              }
            ],
            "sectionBackgroundColor": "#100f0f"
          }
        ]
      }
    },
    {
      "type": "PrimePopularItems",
      "data": {
        "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
        "backgroundColor": "#ffffff",
        "selectedItemIds": [],
        "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
        "showRating": true,
        "menuData": []
      }
    },
    {
      "type": "ModernMenu",
      "data": {}
    },
    {
      "type": "PrimeExperience",
      "data": {
       "headerContent": "<h2><br></h2><h2>Our Culinary Experience</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p><br></p>",
        "cards": [
          {
            "id": "1",
            "title": "<h3 class='text-xl font-semibold mb-2'>Fresh Ingredients</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.</p>",
            "image": "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&h=400&fit=crop",
            "icon": "🥗"
          },
          {
            "id": "2",
            "title": "<h3 class='text-xl font-semibold mb-2'>Expert Chefs</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.</p>",
            "image": "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=600&h=400&fit=crop",
            "icon": "👨‍🍳"
          },
          {
            "id": "3",
            "title": "<h3 class='text-xl font-semibold mb-2'>Warm Ambiance</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nec tellus sed augue semper porta. Mauris massa.</p>",
            "image": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=400&fit=crop",
            "icon": "🏠"
          },
          {
            "id": "4",
            "title": "<h3 class='text-xl font-semibold mb-2'>Customer Satisfaction</h3>",
            "description": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>",
            "image": "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&h=400&fit=crop",
            "icon": "🌟"
          }
        ],
        "backgroundColor": "#fff7f3"
      }
    },
    {
      "type": "PrimeFooter",
      "data": {
        "address": "123 Main Street, Lorem City, Ipsum State 12345",
        "backgroundColor": "#000000",
        "borderColor": "#334155",
        "copyrightText": "<p>© 2025 <strong>Your Restaurant</strong>. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
        "description": "<p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>. Vivamus ut nulla nec justo pretium porta. Integer euismod, magna ac <em>volutpat facilisis</em>, velit purus tempus metus, at <strong>faucibus mauris</strong> sem vel nisi.</p>",
        "email": "info@yourrestaurant.com",
        "hours": "Mon–Thu: 11am–10pm | Fri–Sat: 11am–11pm | Sun: 12pm–9pm",
        "legalLinks": [
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt, nibh vel laoreet pulvinar, neque massa accumsan turpis, sed porta risus mi non purus.</p>",
            "id": "1",
            "label": "Privacy Policy",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ultricies, orci vel interdum tempor, lorem arcu tempor nisi, vel egestas libero magna nec risus.</p>",
            "id": "2",
            "label": "Terms of Service",
            "url": ""
          },
          {
            "enabled": true,
            "content": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut dignissim diam vel nisl vestibulum, nec vestibulum felis euismod.</p>",
            "id": "3",
            "label": "Cookie Policy",
            "url": ""
          }
        ],
        "linkColor": "#f59e0b",
        "phone": "(555) 123-4567",
        "restaurantName": "SnapFeast",
        "socialLinks": [
          {
            "enabled": false,
            "id": "1",
            "platform": "facebook",
            "url": ""
          },
          {
            "enabled": false,
            "id": "2",
            "platform": "instagram",
            "url": ""
          },
          {
            "enabled": false,
            "id": "3",
            "platform": "twitter",
            "url": ""
          },
          {
            "enabled": false,
            "id": "4",
            "platform": "linkedin",
            "url": ""
          },
          {
            "enabled": false,
            "id": "5",
            "platform": "email",
            "url": ""
          },
          {
            "enabled": false,
            "id": "6",
            "platform": "tiktok",
            "url": ""
          },
          {
            "enabled": false,
            "id": "7",
            "platform": "yelp",
            "url": ""
          },
          {
            "enabled": false,
            "id": "8",
            "platform": "tripadvisor",
            "url": ""
          },
          {
            "enabled": false,
            "id": "9",
            "platform": "foursquare",
            "url": ""
          }
        ],
        "textColor": "#f1f5f9"
      }
    }
  ],
  "pages": {
    "our-story": {
      "widgets": [
        {
          "type": "ModernStory",
          "data": {
            "hero": {
              "image": "https://www.leedsindiefood.com/wp-content/uploads/2022/04/LIF19-140519-Web-Ben_Bentley-2520-Web-2000x1335.jpeg",
              "title": "<h2>Lorem Ipsum Our Story</h2>"
            },
            "title": "<h3>The Story of Our Lorem Ipsum Restaurant</h3>",
            "storyContent": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. This is sample content for demonstration purposes and can be replaced later.</p>"
          }
        }
      ],
      "title": "our-story"
    },
    "blog": {
      "widgets": [
        {
          "type": "ModernBlog",
          "data": {
            "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Lorem Ipsum Blog Posts</h2>",
            "subtitle": "<p class='text-gray-600 text-lg'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Discover our latest stories and insights.</p>",
            "posts": [
              {
                "id": "1",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post One</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text.</p>",
                "image": "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/8103728/106960_386746.png",
                "date": "2024-01-01T00:00:00.000Z",
                "readTime": "5 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              },
              {
                "id": "2",
                "title": "<h3 class='text-xl font-bold text-gray-900'>Lorem Ipsum Blog Post Two</h3>",
                "content": "<p class='text-gray-700 leading-relaxed'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>",
                "excerpt": "<p class='text-gray-600'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sample excerpt text for the second blog post.</p>",
                "image": "https://www.thatgoangirl.com/wp-content/uploads/2020/05/anonymous-crop-person-taking-photo-of-food-on-smartphone-at-3850226-1-1440x960.jpg",
                "date": "2024-01-02T00:00:00.000Z",
                "readTime": "3 min",
                "category": "Lorem Ipsum",
                "isEnabled": true
              }
            ],
            "postsPerPage": 6,
            "showCategory": true,
            "showReadTime": true,
            "showAuthor": false,
            "backgroundColor": "#ffffff",
            "textColor": "#1f2937",
            "cardBackgroundColor": "#ffffff",
            "primaryColor": "#EF4444"
          }
        }
      ],
      "title": "blog"
    },
    "events": {
      "widgets": [
        {
          "type": "ModernEvents",
          "data": {
            "isEnabled": true,
            "section": {
              "title": "<h2>Upcoming Events</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stay tuned for our latest events!</p>",
              "primaryColor": "#EF4444",
              "secondaryColor": "#DC2626",
              "accentColor": "#B91C1C",
              "textColor": "#374151"
            },
            "items": [
              {
                "id": "event-1",
                "title": "<h3>Lorem Ipsum Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum. Event details will be updated soon.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-01-01",
                "time": "18:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              },
              {
                "id": "event-2",
                "title": "<h3>Dolor Sit Amet Event</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
                "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
                "date": "2024-02-15",
                "time": "20:00",
                "location": "Lorem Ipsum Venue",
                "isVisible": true
              }
            ]
          }
        }
      ],
      "title": "events"
    },
    "gallery": {
      "widgets": [
        {
          "type": "ModernGallery",
          "data": {
            "section": {
              "title": "<h2>Lorem Ipsum Culinary Artistry</h2>",
              "subtitle": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. A visual celebration of our gastronomic creations.</p>",
              "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony.</p>"
            },
            "images": [
              {
                "id": "1",
                "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Elegant Presentation</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Where artistry meets gastronomy.</p>",
                "isVisible": true
              },
              {
                "id": "2",
                "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Chef's Precision</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Meticulous attention to every detail.</p>",
                "isVisible": true
              },
              {
                "id": "3",
                "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Premium Ingredients</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Only the finest seasonal selections.</p>",
                "isVisible": true
              },
              {
                "id": "4",
                "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
                "title": "<h3>Lorem Ipsum Sophisticated Ambiance</h3>",
                "description": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. An atmosphere of refined elegance.</p>",
                "isVisible": true
              }
            ],
            "cta": {
              "text": "<span>Lorem Ipsum Follow @CulinaryJourney</span>",
              "link": "https://instagram.com/culinaryjourney"
            }
          }
        }
      ],
      "title": "gallery"
    },
    "contact": {
      "widgets": [
        {
          "type": "ModernContactForm",
          "data": {
            "title": "Contact Us",
            "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
            "primaryColor": "#E7000B",
            "textColor": "#1F2937",
            "backgroundColor": "#FFFFFF",
            "formBackgroundColor": "#F9FAFB",
            "cardBackgroundColor": "#FFFFFF",
            "submitButtonText": "SUBMIT",
            "successMessage": "Thank you for reaching out! This is a sample success message.",
            "errorMessage": "Oops! Something went wrong. Please try again later.",
            "contactInfo": {
              "email": {
                "title": "Email Us",
                "description": "Send us an email",
                "address": "info@sample.com"
              },
              "phone": {
                "title": "Call Us",
                "description": "Call us directly",
                "number": "(000) 000-0000"
              },
              "address": {
                "title": "Visit Us",
                "description": "Visit our office",
                "full": "123 Sample Street, Sample City, Country"
              }
            },
            "formFields": {
              "name": {
                "enabled": true,
                "required": true,
                "label": "Name",
                "placeholder": "Your Name"
              },
              "email": {
                "enabled": true,
                "required": true,
                "label": "Email",
                "placeholder": "Your Email"
              },
              "phone": {
                "enabled": true,
                "required": false,
                "label": "Phone",
                "placeholder": "Your Phone"
              },
              "message": {
                "enabled": true,
                "required": true,
                "label": "Message",
                "placeholder": "Your Message"
              }
            }
          }
        }
      ],
      "title": "contact"
    }
  }
}
};

export const getTemplateData = (templateId: string) => {
  return templateData[templateId as keyof typeof templateData] || null;
};
